import type { ListWebhooksByActivityIdResponse } from '@/services/WarrantyApiService/types'
import WarrantyApiService from '@/services/WarrantyApiService/WarrantyApiService'
import { useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'

export const useListWebhooks = (activityId: string) => {
  return useQuery<ListWebhooksByActivityIdResponse, Error>({
    queryKey: ['list-webhooks-by-activity-id'],
    queryFn: async () => {
      const response = await WarrantyApiService.listWebhooksByActivityId(activityId)

      if (response.isWrong()) {
        const error = new Error(response.value.message)
        error.name = response.value.name
        throw error
      }

      return response.value.filter((webhook) => webhook.trigger === 'ATTESTED_TO_CONFORMITY')
    },
    retry: false,
    enabled: false
  })
}

export const useReexecuteWebhook = (tagCode: string, webhookId: Ref<string>) => {
  return useQuery<any, Error>({
    queryKey: ['reexecute-webhook'],
    queryFn: async () => {
      const response = await WarrantyApiService.reexecuteWebhook(tagCode, webhookId.value)

      if (response.isWrong()) {
        const error = new Error(response.value.message)
        error.name = response.value.name
        throw error
      }

      return true
    },
    retry: false,
    enabled: false
  })
}
